import { useState } from 'react';
import { motion } from 'framer-motion';
import Navbar from '../components/common/navbar';
import sarthakImg from '../assets/images/sarthak.jpg';
import {
  Fullpage,
  FullPageSections,
  FullpageSection,
} from '@ap.cx/react-fullpage';

const leadership = [
  {
    name: 'Sarthak Sikdar',
    role: 'Founder & CEO',
    location: 'Delhi, India',
    img: sarthakImg,
  },
];

const marketers = [
  {
    name: 'Aakash Mehta',
    role: 'Head of Growth',
    location: 'Mumbai, India',
    img: 'https://randomuser.me/api/portraits/men/32.jpg',
  },
  {
    name: 'Manvi Gupta',
    role: 'Performance Marketing Lead',
    location: 'Delhi, India',
    img: 'https://randomuser.me/api/portraits/women/44.jpg',
  },
  {
    name: 'Saurab Anand',
    role: 'Brand Strategist',
    location: 'Delhi, India',
    img: 'https://randomuser.me/api/portraits/men/45.jpg',
  },
];

const designers = [
  {
    name: 'Mohd Zuhaib',
    role: 'Creative Designer',
    location: 'Mumbai, India',
    img: 'https://randomuser.me/api/portraits/men/65.jpg',
  },
  {
    name: 'Jaskirat Singh',
    role: 'Senior UI/UX Designer',
    location: 'Pune, India',
    img: 'https://randomuser.me/api/portraits/men/22.jpg',
  },
  {
    name: 'Vedant Mandlik',
    role: 'Motion Designer',
    location: 'Kolkata, India',
    img: 'https://randomuser.me/api/portraits/men/55.jpg',
  },
  {
    name: 'Pooja Sharma',
    role: 'Visual & Brand Designer',
    location: 'Chennai, India',
    img: 'https://randomuser.me/api/portraits/women/68.jpg',
  },
];

const developers = [
  {
    name: 'Abhishek Singh',
    role: 'Lead Full stack Developer',
    location: 'Delhi, India',
    img: 'https://randomuser.me/api/portraits/men/12.jpg',
  },
  {
    name: 'Samson Mendonca',
    role: 'Full-Stack Developer',
    location: 'Mumbai, India',
    img: 'https://randomuser.me/api/portraits/men/36.jpg',
  },
  {
    name: 'Robin Pawar',
    role: 'NextJs Developer',
    location: 'Hyderabad, India',
    img: 'https://randomuser.me/api/portraits/men/41.jpg',
  },
  {
    name: 'Ananya Singh',
    role: 'Mobile Developer',
    location: 'Bangalore, India',
    img: 'https://randomuser.me/api/portraits/women/35.jpg',
  },
];

function MemberCard({ member, index }) {
  const [hovered, setHovered] = useState(false);
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: index * 0.07 }}
      className="flex flex-col items-center gap-y-4 group cursor-default mb-4"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div
        className="relative overflow-hidden rounded-full w-36 h-36 sm:w-44 sm:h-44 lg:w-52 lg:h-52 flex-shrink-0 transition-all duration-300"
        style={{
          boxShadow: hovered ? '0 0 0 3px #24FFFF' : '0 0 0 3px transparent',
        }}
      >
        <img
          src={member.img}
          alt={member.name}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
          loading="lazy"
        />
        <div
          className="absolute inset-0 transition-opacity duration-300"
          style={{
            background:
              'linear-gradient(to top, rgba(36,255,255,0.2) 0%, transparent 60%)',
            opacity: hovered ? 1 : 0,
          }}
        />
      </div>

      <div className="flex flex-col items-center gap-y-1 text-center">
        <p className="text-white font-lato font-[700] text-[15px] sm:text-[17px] lg:text-[20px] leading-snug">
          {member.name}
        </p>
        <p className="text-[#24FFFF] font-lato font-[400] text-[12px] sm:text-[13px] lg:text-[15px]">
          {member.role}
        </p>
      </div>
    </motion.div>
  );
}

function HeroSection() {
  return (
    <div className="bg-black min-h-screen px-5 lg:px-20 flex flex-col items-center justify-center pt-5 pb-0 gap-y-4 text-center">
      <p className="text-white/40 font-lato text-[15px] lg:text-[16px] font-[600] tracking-[0.2em] uppercase">
        The people behind the work
      </p>
      <h1 className="text-white font-lato font-[800] text-[2.2em] sm:text-[3em] lg:text-[4.8em] leading-[1.05]">
        Meet the <span className="text-[#24FFFF]">team</span>
      </h1>
      <p className="text-white/60 font-lato font-[400] text-[14px] lg:text-[18px] leading-relaxed max-w-xl">
        Designers, developers, marketers, and strategists united by one mission.
        Build strong, Scale fast.
      </p>

      {/* Animated scroll indicator */}
      <div className="mt-6 flex flex-col items-center gap-y-2">
        <motion.div
          animate={{ y: [0, 8, 0] }}
          transition={{ duration: 1.4, repeat: Infinity, ease: 'easeInOut' }}
          className="flex flex-col items-center gap-y-1"
        >
          <span className="text-white/30 font-lato text-[11px] tracking-widest uppercase">
            Scroll
          </span>
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5 7.5L10 12.5L15 7.5"
              stroke="#24FFFF"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </motion.div>
      </div>
    </div>
  );
}
function LeadershipSection() {
  return (
    <div className="bg-black min-h-screen px-5 py-16 lg:px-20 lg:py-20 flex flex-col items-center justify-center gap-y-6 overflow-y-auto no-scrollbar">
      <div className="flex flex-col gap-y-2 text-center w-full">
        <p className="text-white/40 font-lato text-[15px] lg:text-[16px] font-[600] tracking-[0.2em] uppercase">
          Leadership
        </p>
        <h2 className="text-white font-lato font-[800] text-[1.9em] sm:text-[2.5em] lg:text-[3.9em] leading-tight">
          Guided by <span className="text-[#24FFFF]">experience.</span>
        </h2>
      </div>

      <div className="flex justify-center gap-8 lg:gap-16 mt-6">
        {leadership.map((m, i) => (
          <MemberCard key={m.name} member={m} index={i} />
        ))}
      </div>

      <p className="text-white font-lato font-[400] text-[14px] lg:text-[16px] text-center opacity-80">
        The vision and voice behind everything we build at Buildatscale.
      </p>
    </div>
  );
}

function GrowthSection() {
  return (
    <div className="bg-black min-h-screen px-5 py-16 lg:px-20 lg:py-20 flex flex-col items-center justify-center gap-y-6 overflow-y-auto no-scrollbar">
      <div className="flex flex-col gap-y-2 text-center w-full">
        <p className="text-white/40 font-lato text-[15px] lg:text-[16px] font-[600] tracking-[0.2em] uppercase">
          Growth &amp; Marketing
        </p>
        <h2 className="text-white font-lato font-[800] text-[1.9em] sm:text-[2.5em] lg:text-[3.9em] leading-tight">
          Driving results, <span className="text-[#24FFFF]">at scale.</span>
        </h2>
      </div>

      <div className="flex justify-center gap-6 sm:gap-8 lg:gap-16 flex-wrap mt-6">
        {marketers.map((m, i) => (
          <MemberCard key={m.name} member={m} index={i} />
        ))}
      </div>

      <p className="text-white font-lato font-[400] text-[14px] lg:text-[16px] text-center opacity-80">
        Growth strategists who turn visibility into measurable business impact.
      </p>
    </div>
  );
}

function DesignSection() {
  return (
    <div className="bg-black min-h-screen px-5 py-16 lg:px-20 lg:py-20 flex flex-col items-center justify-center gap-y-6 overflow-y-auto no-scrollbar">
      <div className="flex flex-col gap-y-2 text-center w-full">
        <p className="text-white/40 font-lato text-[15px] lg:text-[16px] font-[600] tracking-[0.2em] uppercase">
          Design
        </p>
        <h2 className="text-white font-lato font-[800] text-[1.9em] sm:text-[2.5em] lg:text-[3.9em] leading-tight">
          Crafting things <span className="text-[#24FFFF]">people love.</span>
        </h2>
      </div>

      <div className="flex justify-center gap-6 sm:gap-8 lg:gap-12 flex-wrap mt-6">
        {designers.map((m, i) => (
          <MemberCard key={m.name} member={m} index={i} />
        ))}
      </div>

      <p className="text-white font-lato font-[400] text-[14px] lg:text-[16px] text-center opacity-80">
        Pixel-perfect thinkers who craft brands and experiences users remember.
      </p>
    </div>
  );
}

function DevelopersSection() {
  return (
    <div className="bg-black min-h-screen px-5 py-16 lg:px-20 lg:py-20 flex flex-col items-center justify-center gap-y-6 overflow-y-auto no-scrollbar">
      <div className="flex flex-col gap-y-2 text-center w-full">
        <p className="text-white/40 font-lato text-[15px] lg:text-[16px] font-[600] tracking-[0.2em] uppercase">
          Developers
        </p>
        <h2 className="text-white font-lato font-[800] text-[1.9em] sm:text-[2.5em] lg:text-[3.9em] leading-tight">
          Built with <span className="text-[#24FFFF]">precision.</span>
        </h2>
      </div>

      <div className="flex justify-center gap-6 sm:gap-8 lg:gap-12 flex-wrap mt-6">
        {developers.map((m, i) => (
          <MemberCard key={m.name} member={m} index={i} />
        ))}
      </div>

      <p className="text-white font-lato font-[400] text-[14px] lg:text-[16px] text-center opacity-80">
        Developers who ship clean, scalable code that powers every product we
        build.
      </p>

      <div className="border-t border-white/20 pt-8 w-full flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
        <div className="flex flex-col gap-y-1 text-center lg:text-left">
          <h3 className="text-white font-lato font-[700] text-[1.3em] lg:text-[2em] leading-tight">
            Want to join this team?
          </h3>
          <p className="text-white font-lato font-[400] text-[15px] lg:text-[18px]">
            We are always looking for talented builders explore open roles.
          </p>
        </div>
        <div className="flex items-center justify-center lg:justify-end gap-4 flex-shrink-0 flex-wrap">
          <a
            href="/careers"
            className="w-fit font-lato font-[500] text-[0.9em] lg:text-[1em] px-10 py-3 rounded-[30px] transition-opacity duration-200 whitespace-nowrap"
            style={{ background: '#24FFFF', color: '#000' }}
          >
            View open roles
          </a>
          <a
            href="https://buildatscale.com/blog/"
            className="border border-white/25 w-fit text-white font-lato font-[400] text-[0.9em] lg:text-[1em] px-10 py-3 rounded-[30px] hover:border-white/50 transition-colors duration-200 whitespace-nowrap"
          >
            Contact us
          </a>
        </div>
      </div>
    </div>
  );
}

export default function Teams() {
  return (
    <>
      <Navbar />
      <Fullpage>
        <FullPageSections>
          <FullpageSection>
            <HeroSection />
          </FullpageSection>
          <FullpageSection>
            <LeadershipSection />
          </FullpageSection>
          <FullpageSection>
            <GrowthSection />
          </FullpageSection>
          <FullpageSection>
            <DesignSection />
          </FullpageSection>
          <FullpageSection>
            <DevelopersSection />
          </FullpageSection>
        </FullPageSections>
      </Fullpage>
    </>
  );
}
